import { checkboxDefaultInitialState } from "../../components/Filter/checkbox";
import { OrderStatusEnum, OrderStatusText } from "../OrderStatus";
import { OrderStatusERPEnum, OrderStatusERPText } from "../OrderStatusERP";

export const companyFieldNames = {};

export const luftFieldNames = {
  COMPANY: "companyList",
};

export const fieldNames = {
  CREATE_DATE: "createdAt",
  DELIVERY_DATE: "deliveryDate",
  AGENT: "agentList",
  AUTHOR: "authorList",
  STATUS: "statusList",
  PRODUCT_TYPE: "productTypeList",
  STATUS_ERP: "ERPFileStatus",
  PROMOTIONAL_CICLE: "promotionalCicleList",
  MATERIAL: "materialList",
  PRODUCT: "productList",
  ORDER_BY: "orderBy",
  SEARCH: "search",
  ORDER_BY_SUGGESTION: "orderBySuggestion",
};

export const ProductTypeEnum = {
  PRODUCT_TYPE_1: 1,
  PRODUCT_TYPE_2: 2,
  PRODUCT_TYPE_3: 3,
};

export const ProductTypeText = {
  [ProductTypeEnum.PRODUCT_TYPE_1]: "AGT",
  [ProductTypeEnum.PRODUCT_TYPE_2]: "AMG",
  [ProductTypeEnum.PRODUCT_TYPE_3]: "PROMO",
};

export const productTypeOptionList = [
  {
    value: ProductTypeEnum.PRODUCT_TYPE_1,
    label: ProductTypeText[ProductTypeEnum.PRODUCT_TYPE_1],
  },
  {
    value: ProductTypeEnum.PRODUCT_TYPE_2,
    label: ProductTypeText[ProductTypeEnum.PRODUCT_TYPE_2],
  },
  {
    value: ProductTypeEnum.PRODUCT_TYPE_3,
    label: ProductTypeText[ProductTypeEnum.PRODUCT_TYPE_3],
  },
];

export const PreOrderStatusEnum = {
  IS_PRE_ORDER_PENDING: 1,
  IS_PRE_ORDER_APPROVED: 2,
  IS_PRE_ORDER_CANCELED: 3,
};

export const PreOrderStatusText = {
  [PreOrderStatusEnum.IS_PRE_ORDER_PENDING]: 'Pendente',
  [PreOrderStatusEnum.IS_PRE_ORDER_APPROVED]: 'Aprovado',
  [PreOrderStatusEnum.IS_PRE_ORDER_CANCELED]: 'Cancelado',
};

export const preOrderStatusOptionList = [
  {
    value: PreOrderStatusEnum.IS_PRE_ORDER_PENDING,
    label: PreOrderStatusText[PreOrderStatusEnum.IS_PRE_ORDER_PENDING],
  },
  {
    value: PreOrderStatusEnum.IS_PRE_ORDER_APPROVED,
    label: PreOrderStatusText[PreOrderStatusEnum.IS_PRE_ORDER_APPROVED],
  },
  {
    value: PreOrderStatusEnum.IS_PRE_ORDER_CANCELED,
    label: PreOrderStatusText[PreOrderStatusEnum.IS_PRE_ORDER_CANCELED],
  },
];

export const orderStatusOptionList = [
  {
    value: OrderStatusEnum.ORDER_PENDING_APPROVAL,
    label: OrderStatusText[OrderStatusEnum.ORDER_PENDING_APPROVAL],
  },
  // {
  //   value: OrderStatusEnum.ORDER_STATUS_APROVED,
  //   label: OrderStatusText[OrderStatusEnum.ORDER_STATUS_APROVED],
  // },
  {
    value: OrderStatusEnum.ORDER_NOT_APPROVED,
    label: OrderStatusText[OrderStatusEnum.ORDER_NOT_APPROVED],
  },
  // {
  //   value: OrderStatusEnum.ORDER_STATUS_ERP_SUCCESS,
  //   label: OrderStatusText[OrderStatusEnum.ORDER_STATUS_ERP_SUCCESS],
  // },
  {
    value: OrderStatusEnum.ORDER_STATUS_ERP_EXPORT,
    label: OrderStatusText[OrderStatusEnum.ORDER_STATUS_ERP_EXPORT],
  },
  {
    value: OrderStatusEnum.BILLING_ORDER,
    label: OrderStatusText[OrderStatusEnum.BILLING_ORDER],
  },
  {
    value: OrderStatusEnum.BILLED_ORDER,
    label: OrderStatusText[OrderStatusEnum.BILLED_ORDER],
  },
  {
    value: OrderStatusEnum.PREPARING_ORDER,
    label: OrderStatusText[OrderStatusEnum.PREPARING_ORDER],
  },
  {
    value: OrderStatusEnum.PREPARED_ORDER,
    label: OrderStatusText[OrderStatusEnum.PREPARED_ORDER],
  },
  {
    value: OrderStatusEnum.ORDER_SENT_TO_TRANSPORT,
    label: OrderStatusText[OrderStatusEnum.ORDER_SENT_TO_TRANSPORT],
  },
  /* {
    value: OrderStatusEnum.SCHEDULING_ORDER,
    label: OrderStatusText[OrderStatusEnum.SCHEDULING_ORDER],
  },
  {
    value: OrderStatusEnum.TRY_SCHEDULLING_ORDER,
    label: OrderStatusText[OrderStatusEnum.TRY_SCHEDULLING_ORDER],
  },
  {
    value: OrderStatusEnum.ORDER_NOT_SCHEDULED,
    label: OrderStatusText[OrderStatusEnum.ORDER_NOT_SCHEDULED],
  }, */
  {
    value: OrderStatusEnum.ORDER_IN_TRANSPORT,
    label: OrderStatusText[OrderStatusEnum.ORDER_IN_TRANSPORT],
  },
  {
    value: OrderStatusEnum.DELIVERY_ATTEMPT,
    label: OrderStatusText[OrderStatusEnum.DELIVERY_ATTEMPT],
  },
  {
    value: OrderStatusEnum.ORDER_DELIVERED,
    label: OrderStatusText[OrderStatusEnum.ORDER_DELIVERED],
  },
  {
    value: OrderStatusEnum.ORDER_NOT_DELIVERED,
    label: OrderStatusText[OrderStatusEnum.ORDER_NOT_DELIVERED],
  },
  {
    value: OrderStatusEnum.ORDER_CANCELED,
    label: OrderStatusText[OrderStatusEnum.ORDER_CANCELED],
  },
  {
    value: OrderStatusEnum.ORDER_REFUSED,
    label: OrderStatusText[OrderStatusEnum.ORDER_REFUSED],
  },
];

export const orderStatusERPOptionList = [
  {
    value: OrderStatusERPEnum.GENERATED,
    label: OrderStatusERPText[OrderStatusERPEnum.GENERATED],
  },
  // {
  //   value: OrderStatusERPEnum.PENDING,
  //   label: OrderStatusERPText[OrderStatusERPEnum.PENDING],
  // },
  {
    value: OrderStatusERPEnum.ERROR,
    label: OrderStatusERPText[OrderStatusERPEnum.ERROR],
  },
];

/**
 * REPRESENTATIVE TYPES
 */
export const agentType = {
  NAME: "name",
  CATEGORIE: "tagsId",
};

export const agentTypeLabel = {
  [agentType.NAME]: "Nome",
  [agentType.CATEGORIE]: "Categoria",
};

export const agentTypeOptionList = [
  {
    value: agentType.NAME,
    label: agentTypeLabel[agentType.NAME],
  },
  {
    value: agentType.CATEGORIE,
    label: agentTypeLabel[agentType.CATEGORIE],
  },
];

export const agentTypeERP = {
  NAME: "name",
  CATEGORIE: "tagsId",
};

export const agentTypeLabelERP = {
  [agentTypeERP.NAME]: "Nome",
  [agentTypeERP.CATEGORIE]: "Categoria",
};

export const agentTypeOptionListERP = [
  {
    value: agentTypeERP.NAME,
    label: agentTypeLabelERP[agentTypeERP.NAME],
  },
  {
    value: agentTypeERP.CATEGORIE,
    label: agentTypeLabelERP[agentTypeERP.CATEGORIE],
  },
];

/**
 * MATERIAL TYPES
 */
export const materialType = {
  NAME: "name",
  CODE: "code",
};

export const materialTypeLabel = {
  [materialType.NAME]: "Nome",
  [materialType.CODE]: "Código",
};

export const materialTypeOptionList = [
  {
    value: materialType.NAME,
    label: materialTypeLabel[materialType.NAME],
  },
  {
    value: materialType.CODE,
    label: materialTypeLabel[materialType.CODE],
  },
];

/**
 * ORDER BY SUGGESTION
 */
export const orderBySuggestionType = {
  SUGGESTION: "suggestion",
  ORDER_NUMBER: "orderNumber",
  CREATED_AT: "createdAt",
};

export const orderBySuggestion = {
  [orderBySuggestionType.SUGGESTION]: "Sugestão de pareamento",
  [orderBySuggestionType.ORDER_NUMBER]: "Nº do pedido",
  [orderBySuggestionType.CREATED_AT]: "Data de criação",
};

export const orderBySuggestionList = [
  {
    value: orderBySuggestionType.SUGGESTION,
    label: orderBySuggestion[orderBySuggestionType.SUGGESTION],
  },
  {
    value: orderBySuggestionType.ORDER_NUMBER,
    label: orderBySuggestion[orderBySuggestionType.ORDER_NUMBER],
  },
  {
    value: orderBySuggestionType.CREATED_AT,
    label: orderBySuggestion[orderBySuggestionType.CREATED_AT],
  },
];

export const filtersInitialState = {
  [luftFieldNames.COMPANY]: {},
  [fieldNames.CREATE_DATE]: {
    from: null,
    to: null,
  },
  [fieldNames.DELIVERY_DATE]: {
    from: null,
    to: null,
  },
  [fieldNames.AGENT]: {},
  [fieldNames.AUTHOR]: {},
  [fieldNames.STATUS]: checkboxDefaultInitialState(orderStatusOptionList),
  [fieldNames.STATUS_ERP]: {},
  [fieldNames.PROMOTIONAL_CICLE]: {},
  [fieldNames.MATERIAL]: {},
  [fieldNames.PRODUCT]: {},
  [fieldNames.PRODUCT_TYPE]: checkboxDefaultInitialState(productTypeOptionList),
  [fieldNames.ORDER_BY_SUGGESTION]: {},
};
